import instance from "../utils/axios";

class FormsService {
  async getTabList(value) {
    return await instance.get("/crm/dynamicTab/getSelectedList?host=" + value);
  }

  async getFormDataList(pageIndex, keyword, formTableName, workflowTemplateId) {
    return await instance.post(
      "/crm/dynamicTab/getFormDataList?formTableName=" +
        formTableName +
        "&workflowTemplateId=" +
        workflowTemplateId,
      {
        pageSize: 10,
        pageIndex: pageIndex,
        dictionaryNames:
          "advisorId.base_staff,advisorId.base_staff.avatar,creatorId.base_staff,creatorId.base_staff.avatar,customerId.crm_customer",
        expressions: '[{"field": "数量", "expression": "count(1)"}]',
        fuzzySearch: keyword,
        sortField: "createTime",
        sort: "asc",
      }
    );
  }

  /**
   * 获取客户详情下，每个单据列表数据
   */
  async getFormDataListByCustomerId(
    pageIndex,
    formTableName,
    customerId,
    workflowTemplateId,
    dictionary
  ) {
    return await instance.post(
      "/crm/dynamicTab/getFormDataList?formTableName=" +
        formTableName +
        "&customerId=" +
        customerId +
        "&workflowTemplateId=" +
        workflowTemplateId,
      {
        pageSize: 8,
        pageIndex: pageIndex,
        dictionaryNames:
          "advisorId.base_staff,advisorId.base_staff.avatar,creatorId.base_staff,creatorId.base_staff.avatar,customerId.crm_customer" +
          (dictionary ? "," + dictionary : ""),
        expressions: '[{"field": "数量", "expression": "count(1)"}]',
        sortField: "createTime",
        sort: "desc",
      }
    );
  }

  /**
   * 根据字段获取动态表单数据
   */
  async getDynamicTabById(uuid) {
    return await instance.get("/crm/dynamicTab/getDynamicTabById?uuid=" + uuid);
  }

  /**
   * 获取当前单据可创建的其他表单
   * @param uuid
   * @returns {Promise<void>}
   */
  async getCreatableForms(dynamicTabId, customerId, prevPrimaryKey) {
    return await instance.get(
      "/crm/dynamicTab/getRelevanceDynamicForm?dynamicTabId=" +
        dynamicTabId +
        "&hostPrimaryKey=" +
        customerId +
        "&prevPrimaryKey=" +
        prevPrimaryKey
    );
  }

  /**
   * 获取当前单据可创建的其他表单
   * @param uuid
   * @returns {Promise<void>}
   */
  async getFormParameter(
    dynamicTabId,
    customerId,
    prevPrimaryKey,
    createFormTab
  ) {
    return await instance.get(
      "/crm/dynamicTab/getFormParameter?dynamicTabId=" +
        dynamicTabId +
        "&createFrom=" +
        prevPrimaryKey +
        "&hostMajorKey=" +
        customerId +
        "&createFormTab=" +
        createFormTab
    );
  }
}

export default new FormsService();
